import React from 'react';
import { Select } from 'antd';
import { useI18n } from '../../shared/i18n';

interface LanguageSwitcherProps {
  compact?: boolean;
  style?: React.CSSProperties;
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
  compact,
  style,
}) => {
  const { language, languages, setLanguage, t } = useI18n();

  return (
    <Select
      aria-label={t('language.label')}
      title={t('language.label')}
      value={language}
      onChange={setLanguage}
      popupMatchSelectWidth={false}
      style={{ minWidth: compact ? 132 : 180, ...style }}
      options={languages.map((item) => ({
        value: item.code,
        label: compact
          ? item.code.replace('-', ' ')
          : t(`language.options.${item.code}`),
      }))}
    />
  );
};

export default LanguageSwitcher;
